import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

// Router
import { getRoute } from '../../../entry/routes';

// Styles
import styles from './Nav.styl';

const cx = classNames.bind(styles);

export default function Nav(props) {
  const { className } = props;

  const footerLinksList = useSelector(state => state.ui.footerLinks.list);

  if (!footerLinksList.length) {
    return null;
  }

  return (
    <ul className={cx('Nav', className)}>
      {footerLinksList.map(item =>
        item.link.includes('http') ? (
          <li className={cx('Nav__item')} key={item.link}>
            <a
              className={cx('Nav__link')}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.name}
            </a>
          </li>
        ) : (
          <li className={cx('Nav__item')} key={item.link}>
            <Link to={getRoute(item.link)} className={cx('Nav__link')}>
              {item.name}
            </Link>
          </li>
        ),
      )}
    </ul>
  );
}

Nav.defaultProps = {
  className: '',
};

Nav.propTypes = {
  className: PropTypes.string,
};
